import { render, staticRenderFns } from "./ElementLogPermohonan.vue?vue&type=template&id=6f5b2700&"
import script from "./ElementLogPermohonan.vue?vue&type=script&lang=js&"
export * from "./ElementLogPermohonan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports